import { type FC, type ReactNode } from "react";

import { SnapSSOAuthProvider } from "../../core/sso-auth/context";

export const AppSSOAuthProvider: FC<{ children?: ReactNode }> = ({ children }) => {
    return <SnapSSOAuthProvider>{children}</SnapSSOAuthProvider>;
};
